export default __webpack_public_path__ + "static/badhabit-4ced1852d651c686ff0ba6fd49c2a76d.png";